import createIsAsyncValidating from './selectors/isAsyncValidating';
import plain from './structure/plain';

export default createIsAsyncValidating(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/isAsyncValidating.js
// module id = 495
// module chunks = 0